<ng-container *ngIf="detail">
    <shared-accesscontrol-transitions [accessControlId]="accessControlId" [phaseId]="detail.phaseId"
        (refresh)="onRefresh()" (phaseChanged)="phaseChanged.emit($event)"></shared-accesscontrol-transitions>
</ng-container>